var map = {
	"./parachute 1.jpg": 24193,
	"./parachute.jpg": 16988,
	"./rat 1.jpg": 40269,
	"./rocket 01.jpg": 40740,
	"./rocket 2.jpg": 71199,
	"./rocket 3.jpg": 58530,
	"./rocket.jpg": 77869,
	"./stilite 2.jpg": 58969,
	"./stilite 3.jpg": 37916,
	"./zirafee 1.jpg": 36236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78427;